import '../../style/mobile/blog/MBlog.scss';
import img1 from '../../../assets/blog/julian-paul-IP1oEacoXkM-unsplash.png';
import img2 from '../../../assets/blog/robert-katzki-jbtfM0XBeRc-unsplash.png';
import img3 from '../../../assets/blog/rod-long-eWc6BKWduMQ-unsplash.png';
import img4 from '../../../assets/blog/christopher-gower-m_HRfLhgABo-unsplash.jpg';
import img5 from '../../../assets/blog/agatha-depine-dJL6L7YFh5c-unsplash.jpg';
import React from "react";
import moment from "jalali-moment";


let data = [
  {
    id:1,
    title:"چرا دانش آموزان تنبلی می کنند ؟ ",
    subtitle:"دانش‌‌آموز گرامی شما می توانید در صورتی که پاسخ خود را از طریق صفحه راهنمای آزمون پیدا نکردید اقدام به تماس با موسسه ترویج فرهنگ قرآنی نمایید. توجه فرمائید به علت حجم بالای تماس‌های ورودی پاسخ به شما کمی زمانبر خواهد بود",
    date:"2021-11-03T12:00:00.180Z",
    img:img1
  },
  {
    id:2,
    title:"بهترین کتاب‌ها برای شروع فلسفه",
    subtitle:"شاید شما هم جزو افرادی باشید که دوست دارند که فلسفه رو شروع کنند ولی نمیدونید باید ار کجا شروع کنید که دلسرد نشوید. در این مطلب به پنج کتاب درباره فلسفه می‌پردازیم که برای شروع فلسفه مناسب هستند.",
    date:"2021-11-01T12:00:00.180Z",
    img:img2
  },
  {
    id:3,
    title:"خلاقیت در معماری",
    subtitle:"لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است،",
    date:"2021-10-28T12:00:00.180Z",
    img:img3
  },
  {
    id:4,
    title:"محبوب‌ترین زبان‌های برنامه‌نویس 2021",
    subtitle:"لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است،",
    date:"2021-10-28T12:00:00.180Z",
    img:img4
  },
  {
    id:5,
    title:"قدیمی‌ترین مدرسه جهان",
    subtitle:"دانش‌‌آموز گرامی شما می توانید در صورتی که پاسخ خود را از طریق صفحه راهنمای آزمون پیدا نکردید اقدام به تماس با موسسه ترویج فرهنگ قرآنی نمایید. توجه فرمائید به علت حجم بالای تماس‌های ورودی پاسخ به شما کمی زمانبر خواهد بود",
    date:"2021-10-28T12:00:00.180Z",
    img:img5
  },
]

const MBlog=()=>{
  moment.locale("en");
  return(
    <div className="MBlog">
      <div className="MBlog-title">وبلاگ</div>
      <div className="MBlog-first-item">
        <div className="MBlog-first-item-img-container">
          <img src={data[0].img} alt="img-item" />
          <div className="MBlog-first-item-img-container-date">
            {moment(data[0].date, 'YYYY/MM/DD').format('jYYYY/jM/jD')}
          </div>
        </div>
        <div className="MBlog-first-item-title">{data[0].title}</div>
        <div className="MBlog-first-item-subtitle">{data[0].subtitle}</div>
      </div>
      <div className="MBlog-body">
        {data.map((item,index)=>(
          <React.Fragment key={item.id}>
            {index>0 && (<div key={item.id} className="MBlog-body-item">
              <div className="MBlog-body-item-img-container">
                <img src={item.img} alt="img-item" />
                <div className="MBlog-body-item-img-container-date">
                  {moment(item.date, 'YYYY/MM/DD').format('jYYYY/jM/jD')}
                </div>
              </div>
              <div className="MBlog-body-item-title">{item.title}</div>
              <div className="MBlog-body-item-subtitle">{item.subtitle}</div>
            </div>)}
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

export default MBlog;